import { combineReducers } from 'redux';

import plans from './plans/reducer';
import settings from './settings/reducer';
import users from './users/reducer';

export default combineReducers({
  paths: paths => paths || {},
  plans,
  settings,
  users,
});
